var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutopay = function SvgAutopay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.609 17.623c1.804-4.274.185-9.323-3.937-11.703a9.33 9.33 0 0 0-9.298-.022L8.216 3.872a11.66 11.66 0 0 1 11.622.028c5.24 3.024 7.245 9.499 4.804 14.897l1.566.904-4.86 2.583-.192-5.5zM5.4 10.383c-1.805 4.274-.185 9.323 3.937 11.703a9.33 9.33 0 0 0 9.298.022l1.158 2.026a11.66 11.66 0 0 1-11.622-.027c-5.24-3.025-7.245-9.5-4.804-14.898l-1.566-.904 4.86-2.583.192 5.5zm10.254 6.92-3.3-3.3-3.3 3.3-1.65-1.65 4.95-4.95 3.3 3.3 3.3-3.3 1.65 1.65z"
  })));
};
export default SvgAutopay;